import {
  Flex,
  Form,
  TextV2 as Text,
  Colors,
} from '@pinchenterprisesnpm/friday-ui'
import { connect, FormikProps } from 'formik'
import { useSelector } from 'react-redux'
import { IShiftBadgesFormValues } from '@src/features/shift-post-v2/steps/screening-requirements-step/components/screening-section/screening-section.types'
import {
  selectShiftAutoAcceptCertificates,
  selectShiftAutoAcceptCertificatesIsFetching,
} from '@src/data/business/ShiftAutoAcceptCertificates/selectors'
import { useShiftBadgesForm } from '../../hooks'
import { CheckboxCard } from './shift-badges.styles'

const { Checkbox } = Form

interface IShiftBadgesProps {
  formik?: FormikProps<IShiftBadgesFormValues>
}

// We have to use the HOC connect here because we need to access the formik instance from the parent component
export const ShiftBadges = connect<IShiftBadgesProps>(({ formik }) => {
  const autoAcceptCertificates = useSelector(selectShiftAutoAcceptCertificates)
  const isFetching = useSelector(selectShiftAutoAcceptCertificatesIsFetching)
  const { handleChange, isCertificateSelected } = useShiftBadgesForm(
    formik,
    autoAcceptCertificates,
  )

  if (isFetching) {
    return <div>Loading certificates...</div>
  }

  if (!autoAcceptCertificates || autoAcceptCertificates.length === 0) {
    //TODO: Add a proper error message this is just a placeholder for debugging
    return <div>No certificates available</div>
  }
  //TODO: This is a temporary fix to prevent the checkbox from being checked when the card is clicked.
  const handleCardClick = (certificateId: number) => (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    handleChange(certificateId)
  }

  return (
    <Flex direction="column" width="100%">
      {autoAcceptCertificates.map(certificate => (
        <CheckboxCard
          key={certificate.id}
          onClick={handleCardClick(certificate.certificate.id)}
          p={16}
          m={10}
          flexDirection="column"
        >
          <Flex direction="row" align="center">
            <Checkbox
              value={isCertificateSelected(certificate.certificate.id)}
              borderRadius="4px"
              borderWidth="2px"
              borderColor={Colors.muted}
              backgroundColor={Colors.white}
              onChange={(e: any) => {
                e.preventDefault()
                e.stopPropagation()
              }}
            />
            <Text variant="h6">{certificate.certificate.name}</Text>
          </Flex>
          <Flex>
            <Text color="gray" variant="small">
              {certificate.certificate.description}
            </Text>
          </Flex>
        </CheckboxCard>
      ))}
    </Flex>
  )
})
